var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0703125,
    y: 0.789795,
    width: 71.01,
    height: 71.01,
    rx: 35.505,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6906 25.0968V38.3638C31.6906 39.6905 32.017 40.7119 32.6699 41.4279C33.3227 42.1439 34.2809 42.5019 35.5444 42.5019C36.8079 42.5019 37.7766 42.1439 38.4505 41.4279C39.1244 40.7119 39.4613 39.6905 39.4613 38.3638V25.0968H44.8629V38.3322C44.8629 40.3118 44.4417 41.9859 43.5994 43.3547C42.757 44.7236 41.6198 45.7554 40.1878 46.4504C38.7769 47.1453 37.1975 47.4928 35.4496 47.4928C33.7017 47.4928 32.1329 47.1558 30.743 46.482C29.3742 45.787 28.2896 44.7552 27.4894 43.3863C26.6892 41.9965 26.2891 40.3118 26.2891 38.3322V25.0968H31.6906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.af323d1ace2bef6f599f220fc2454f8f.svg";
export { ForwardRef as ReactComponent };